export default __webpack_public_path__ + "static/media/m-summerkhashlama.8e6b22a6.png";